var th = require('./three.js');
var tw = require('./tween.js');
require('./controls/OrbitControls.js');
require('./controls/OrbitControls.js');

var nomIndex = require("../../../static/index.json");

var camera, controls, renderer, models = [],
  scene;

var visioneuse = visioneuse || function(parameters) {

  this.containerId = parameters.containerId;
  this.drawingCanvasId = parameters.drawingCanvasId;

  this.materials = {};
  this.arrayMeshs = [];
  this.group = parameters.group;
  this.arrayMaterials = [];
  this.arrayTransparentMaterials = [];
  this.indexMaterials = {};
  this.isResising = false;
  this.totalMesh = 0;
  this.totalLoaded = 0;
  this.totalLoad = 0;
  this.loadingFilesName = parameters.loadingFilesName;
  this.geometries = {};
  this.explodedGeometries = {};
  this.combinedMeshs = {};
  this.combinedExplodedMeshs = {};
  this.onLoadNextShape = parameters.onLoadNextShape;
  this.onLoadMergedFile = parameters.onLoadMergedFile;
  this.onLoadFinished = parameters.onLoadFinished;
  this.isLoggerMouseDown = false;
  this.objects = [];
  this.objsOnly = [];
  this.$$ = parameters.dom7;
  this.onObjectClick = parameters.onObjectClick;
  this.selectedObj = null;
  this.selectedObjEdge = null;
  this.edgeEnabled = true;

  var self = this;

  this.drawLineData = {
    draw: false,
    fromCoord: {},
    toObjName: ""
  }

  for (let i in parameters.geometries) {
    let key = parameters.geometries[i];
    this.objects[key] = [];
    this.geometries[key] = new th.THREE.Geometry();
  }

  for (let i in parameters.explodedGeometries) {
    let key = parameters.explodedGeometries[i];
    this.objects[key] = [];
    this.explodedGeometries[key] = new th.THREE.Geometry();
  }


  var self = this;
  this.$$('#logger').on('mousedown', function() {
    self.isLoggerMouseDown = true;
  })
  this.$$('#logger').on('mouseup', function() {
    self.isLoggerMouseDown = false;
  })

  var isMouseMove = false;
  var touchstartTimeout = null;
  var isOkToSelect = false;
  var timeTouch = null;

  var canvas = document.getElementById(self.containerId);

  canvas.addEventListener('mousedown', onmousedown, false);
  canvas.addEventListener('mousemove', onmousemove, false);
  canvas.addEventListener('touchmove', onmousemove, false);
  canvas.addEventListener('mouseup', onmouseup, false);

  canvas.addEventListener('touchstart', function(event) {
    if (touchstartTimeout != null)
      touchstartTimeout = clearTimeout(touchstartTimeout);

    isOkToSelect = true;
    setTimeout(function(){
      isOkToSelect = false;
    }, 200);

    touchstartEvent = event;

  }, false)

  canvas.addEventListener('touchend', function(event) {

    event.preventDefault();


    if (touchstartEvent.touches.length > 1)
      retun;

    event.clientX = touchstartEvent.touches[0].clientX;
    event.clientY = touchstartEvent.touches[0].clientY;
    if (isOkToSelect){
    onclickOnly(event);}

    isOkToSelect = true;

  }, false);


  function onmousedown(e) {
    isMouseMove = false;
  }

  function onmousemove(e) {
    isMouseMove = true;
  }

  function onmouseup(e) {
    var isRightMB;
    if ("which" in e)
      isRightMB = e.which == 3;

    if (!isMouseMove && !isRightMB) {
      onclickOnly(e);
    }
    isMouseMove = false;
  }

  function onclickOnly(event) {
    event.preventDefault();
    var mouse = new th.THREE.Vector2();
    var raycaster = new th.THREE.Raycaster();
    mouseX = event.clientX - self.$$('#' + self.containerId).offset().left;
    mouseY = event.clientY - self.$$('#' + self.containerId).offset().top;
    mouse.x = (mouseX / renderer.domElement.clientWidth) * 2 - 1;
    mouse.y = -(mouseY / renderer.domElement.clientHeight) * 2 + 1;
    raycaster.setFromCamera(mouse, camera);

    var intersects = raycaster.intersectObjects(self.objsOnly);

    if (intersects.length > 0) {
      self.onObjectClick(intersects);
    }
  }

  this.reload();

}

visioneuse.prototype.reload = function() {
  var self = this;

  self.initScene();
  self.loadAll();
  this.stopAnimate = false;
  renderer.domElement.addEventListener('loaded', function() {
    self.animate();
  });
}

visioneuse.prototype.animate = function() {
  if (typeof renderer == null || this.stopAnimate)
    return;
  var self = this;

  if (self.isResising) {
    var WIDTH = self.$$(self.canvasContainer).width(),
      HEIGHT = self.$$(self.canvasContainer).height();

    renderer.setSize(WIDTH, HEIGHT);
    camera.aspect = WIDTH / HEIGHT;
    camera.updateProjectionMatrix();
  }

  tw.TWEEN.update();

  controls.update();

  if(controls.target.distanceTo( controls.object.position ) > 500){
    this.disableEdge();
  }else{
    this.enableEdge();
  }
  if (this.drawLineData.draw) {
    this.drawingLineToObj(this.drawLineData.fromCoord, this.drawLineData.toObjName);
  }

  renderer.render(scene, camera);
  requestAnimationFrame(function() {
    self.animate();
  });

  debug();

  function debug() {

    if (self.isLoggerMouseDown)
      return;
    document.getElementById(
        'logger').innerHTML = "position / rotation / target: " +
      "<br>" +
      //position
      camera.position.x.toFixed(2) + "" +
      "," + camera.position.y.toFixed(2) +
      "," + camera.position.z.toFixed(2) +
      //rotation
      "," + camera.rotation.x.toFixed(2) +
      "," + camera.rotation.y.toFixed(2) +
      "," + camera.rotation.z.toFixed(2) +
      //controlstarget
      "," + controls.target.x.toFixed(2) +
      "," + controls.target.y.toFixed(2) +
      "," + controls.target.z.toFixed(2);
  }
}

visioneuse.prototype.loadAll = function() {
  var self = this;
  var THREE = th.THREE;
  var loader = new THREE.FileLoader();
  var totalLoad = 0;
  var loaderIndex = 0;
  var loaderGroupIndex;
  var loadedGroup = 0;
  var allMesh = [];
  var allMeshsData = [];
  var loadStartTime=0;

  var contentLength = 7416041;
  var contentLength = 5330000;
  loadShapes();

  function loadShapes() {
    for (let i in self.loadingFilesName) {
      loader.load("static/export_json/" + self.loadingFilesName[i] + ".json?t="+Date.now(), function (text) {

        var meshs = JSON.parse(text);

        allMesh = allMesh.concat(meshs);
        allMesh.concat(meshs);
        loadedGroup++;
        if (loadedGroup == self.loadingFilesName.length) {
          self.totalMesh = allMesh.length;
          loader.load("static/export_json/" + self.loadingFilesName[i] + "Merged.json?t=" + Date.now(), function (text) {

          allMeshsData = JSON.parse(text);

          loadStartTime=Date.now();
          loadNextShape();
        }, function ( e ) {  ;
                // if (e.lengthComputable) {
                  // self.$$('#homeIntro').text(e.loaded);
                self.onLoadMergedFile(self.totalMesh, e.loaded / contentLength);
            	 });
            }
      });
    }
  }


  function loadNextShape() {
    loadMesh(allMeshsData[self.totalLoaded], function () {
      self.totalLoaded++;
      if (self.totalLoaded == self.totalMesh) {
        self.isLoading = false;

        self.rebuildAllGeometries();
        self.buildMesh("all");
        self.addGroup();

        //            self.rebuildAllExplodedGeometries();
        //            self.buildExplodedMesh("all");
        //            self.addExplodedGroup();

        self.animate();

       self.$$("#loader").hide();

      } else {
        if(Date.now() - loadStartTime >50 || self.totalLoaded == self.totalMesh -1 ){
             if(self.totalLoaded == self.totalMesh -1)
              self.onLoadFinished();
              setTimeout(function(){
                self.onLoadNextShape(self.totalLoaded);

                self.$$('#loader').hide().show(0);

                loadStartTime = Date.now();

                loadNextShape();
              },10)


           }else {
             loadNextShape();
           }
      }
    });
    totalLoad++;
  }

  function loadMesh(json, done) {
    if(typeof json == "undefined"){
      done();
      return;
    }
    //var json = JSON.parse(text); // here you have access to the whole json.
    var model = new THREE.JSONLoader().parse(json);
    var object = new THREE.Mesh(model.geometry);

    self.objsOnly.push(object);
    object.tags = json.metadata.tags;
    if(typeof json.metadata.name == "undefined"){
      filename  = "no_name";
    }else {
      filename = json.metadata.name.replace(/^.*[\\\/]/, '').replace('.json', '');
    }
    filename = filename.replace(/%23/g, '#').replace(/cross/g, '#');


    if(filename.match(/^.{1,2}[0-9]{3}$/)){
      index = filename;
    }else{
      let match = filename.match(/.+_(.{1,2}[0-9]{3})$/)
        if(match){
          index = match[1];
        }
    }
    object.name = index;

    // var materialName = json.metadata.material.replace(/\.[0-9]{3}$/, "");

    var colorIndex = index.match(/([A-ZaZ]+)([0-9]+)/);
    if (colorIndex)
      var materialName = colorIndex[1];
    else
      var materialName = "default";

    if (self.materials[materialName] != undefined) {
      var color = self.materials[materialName].color.getHex();
      if (color >= 0x151515) {
        revertColor = 0X000000;
      } else {
        revertColor = 0X666666;
      }
      var currentMaterial = self.indexMaterials[materialName];
    } else {
      var currentMaterial = self.indexMaterials["default"];
      var revertColor = 0x000000;
    }

    var edges = new THREE.EdgesGeometry(model.geometry, 30);
    var line = new THREE.LineSegments(edges, new THREE.LineBasicMaterial({
      linewidth: 2,
      color: revertColor
    }));

    var added = false;
    for (let i in self.geometries) {
      if (object.tags.includes(i)) {
        let data = {
          "obj": object,
          "material": currentMaterial,
          'index': index,
          'line': line
        };
        if (json.metadata.explodedTranslation != undefined) {
          data.explodedTranslation = json.explodedTranslation;
        }
        self.objects[i].push(data);
        added = true;
      }
    }



    // for (let i in self.explodedGeometries) {
    //   if (json.metadata.explodedTranslation !== undefined) {
    //
    //     if (json.metadata.explodedTranslation[i] !== undefined) {
    //       let data = {
    //         "obj": object,
    //         "material": currentMaterial
    //       };
    //       data.explodedTranslation = json.metadata.explodedTranslation;
    //       self.objects[i].push(data);
    //     }
    //   }
    // }
    if (added == false) {
      let data = {
        "obj": object,
        "material": currentMaterial,
        'index': index,
        'line': line
      };
      if (json.metadata.explodedTranslation != undefined) {
        data.explodedTranslation = json.metadata.explodedTranslation;
      }
      self.objects["all"].push(data);
    }


    done();

    // loader.load(path, onFileLoaded(path), function() {},
    //   function() {
    //     done();
    //   });
  }

}

visioneuse.prototype.buildGeometry = function(groupName) {

  if (this.group) {
    this.geometries[groupName] = new th.THREE.Geometry();
    for (let i in this.objects[groupName]) {
      var object = this.objects[groupName][i].obj;
      var material = this.objects[groupName][i].material;
      this.geometries[groupName].merge(object.geometry, object.matrix, material);
    }
  } else {
    for (let i in this.objects[groupName]) {
      this.objects[groupName][i].obj;
      this.objects[groupName][i].material = this.arrayMaterials[this.objects[groupName][i].material];
      var material = this.objects[groupName][i].material.clone();
      this.objects[groupName][i].obj.material = material;
      this.objects
    }
  }
}

visioneuse.prototype.rebuildAllGeometries = function() {
  for (let groupName in this.geometries) {
    this.buildGeometry(groupName);
  }
}

visioneuse.prototype.buildExplodedGeometry = function(groupName) {
  if (this.group == false)
    return;
  this.explodedGeometries[groupName] = new th.THREE.Geometry();
  for (let i in this.objects[groupName]) {
    let object = this.objects[groupName][i].obj;
    let material = this.objects[groupName][i].material;
    let noTranslation = false;
    if (this.objects[groupName][i].explodedTranslation == undefined) {
      noTranslation = true;
    } else if (this.objects[groupName][i].explodedTranslation[groupName] == undefined) {
      noTranslation = true;
    }

    if (noTranslation == true) {
      console.log('warning: exploded translation not defined for ' + i + "in group " + groupName);
      continue;
    } else {
      let translation = this.objects[groupName][i].explodedTranslation[groupName];
      if (translation != undefined) {
        object.position.set(translation[0], translation[2], -translation[1]);
        object.updateMatrix();
        this.explodedGeometries[groupName].merge(object.geometry, object.matrix, material);
      }
    }

  }
}

visioneuse.prototype.rebuildAllExplodedGeometries = function() {
  for (let groupName in this.explodedGeometries) {
    this.buildExplodedGeometry(groupName);
  }
}

visioneuse.prototype.drawLine = function(from, to) {
  var canvas = document.getElementById(this.drawingCanvasId);
  canvas.width = this.$$("#" + this.containerId).width();
  canvas.height = this.$$("#" + this.containerId).height();
  var ctx = canvas.getContext("2d");
  ctx.beginPath();
  ctx.moveTo(from.x, from.y);
  ctx.lineTo(to.x, to.y);
  ctx.stroke();
}

visioneuse.prototype.drawingLineToObj = function(fromCoord, toObjName) {
  var coord = this.getObjectScreenPosition(toObjName);

  this.drawLine(fromCoord, coord);
}

visioneuse.prototype.startDrawingLineToObj = function(fromCoord, toObjName) {
  this.drawLineData.draw = true;
  this.$$('#' + this.drawingCanvasId).css('opacity', 1);
  this.drawLineData.fromCoord = fromCoord;
  this.drawLineData.toObjName = toObjName;
}

visioneuse.prototype.stopDrawing = function() {
  this.drawLineData.draw = false;
  var canvas = document.getElementById(this.drawingCanvasId);
  this.$$('#' + this.drawingCanvasId).css('opacity', 0);

  let context = canvas.getContext('2d');
  context.clearRect(0, 0, canvas.width, canvas.height);
}

visioneuse.prototype.stopDrawingLineToObj = function() {
  this.drawLineData.draw = false;
}

visioneuse.prototype.selectObj = function(object) {
  if (this.selectedObj) {
    scene.remove(this.selectedObjEdge);
    if(this.selectedObj)
    this.selectedObj.material.emissiveIntensity = 0;
  }
  this.selectedObj = object;
  this.selectedObjEdge = null;

  if (object != false) {
    this.selectedObj.material.emissiveIntensity = 0.6;
    var edges = new th.THREE.EdgesGeometry(this.selectedObj.geometry, 30);
    this.selectedObjEdge = new th.THREE.LineSegments(edges, new th.THREE.LineDashedMaterial({
      color: 0x0364BF,
      dashSize: 1,
      gapSize: 1,
      linewidth: 1
    }));
    scene.add(this.selectedObjEdge);
  }
}

visioneuse.prototype.getObjectScreenPosition = function(name) {
  var self = this;
  obj = this.getObjects([name]);
  if (obj.length) {
    return toScreenPosition(obj);
  } else {
    return false;
  }

  function toScreenPosition(obj) {
    var vector = new th.THREE.Vector3();

    var widthHalf = 0.5 * renderer.context.canvas.width;
    var heightHalf = 0.5 * renderer.context.canvas.height;

    var vector = self.getCenterPoint(obj);
    vector.project(camera);


    vector.x = (vector.x * widthHalf) + widthHalf;
    vector.y = -(vector.y * heightHalf) + heightHalf;

    return {
      x: vector.x,
      y: vector.y
    };

  };

}

visioneuse.prototype.getCenterPoint = function(objs) {
  if(objs.length ==0)
    return {x:0,y:0,z:0};

  var center = null;
  for(i in objs){
    if(center == null){
      center = getCenter(objs[i].obj);
    }else {
      center.add(getCenter(objs[i].obj));
    }
  }
  center.divideScalar(objs.length);

  function getCenter(mesh){
    var middle = new th.THREE.Vector3();
    var geometry = mesh.geometry;

    geometry.computeBoundingBox();

    middle.x = (geometry.boundingBox.max.x + geometry.boundingBox.min.x) / 2;
    middle.y = (geometry.boundingBox.max.y + geometry.boundingBox.min.y) / 2;
    middle.z = (geometry.boundingBox.max.z + geometry.boundingBox.min.z) / 2;

    mesh.localToWorld(middle);
    return middle;
  }

  return center;
}

visioneuse.prototype.setObjectsOpacity = function(objectsName, opacity) {
  var objs = this.getObjects(objectsName);
  var step = (1 / 200);
  for (let i in objs) {

    objs[i].obj.material.opacity = opacity;
    objs[i].line.material.transparent = true;
    objs[i].line.material.opacity = opacity;
    if (opacity < 0.5) {
      objs[i].line.visible = false;
    } else if(this.edgeEnabled){
      objs[i].line.visible = true;
    }
    //      if (objs[i].material.opacity < opacity) {
    //         setOpacityUp(objs[i]);
    //      } else if (objs[i].material.opacity > opacity) {
    //         setOpacityDown(objs[i]);
    //      }
  }

  function setOpacityDown(obj) {
    if (obj.material.opacity > opacity) {
      obj.material.opacity -= step;
      requestAnimationFrame(function() {
        setOpacityDown(obj);
      });
    }
  };

  function setOpacityUp(obj) {
    if (obj.opacity < opacity) {
      obj.opacity += step;
      requestAnimationFrame(setOpacityUp);
    }
  }
}

visioneuse.prototype.enableEdge = function(){
  if(!this.edgeEnabled){
    var objs = this.getObjects("all");
    for(let i in objs){
      if(objs[i].obj.material.opacity > 0.5){
        objs[i].line.visible = true;

      }
    }
    this.edgeEnabled = true;
  }
}
visioneuse.prototype.disableEdge = function(){
  if(this.edgeEnabled){
    var objs = this.getObjects("all");
    for(let i in objs){
      objs[i].line.visible = false;
    }
    this.edgeEnabled = false;
  }
}

visioneuse.prototype.setObjectsColor = function(objectsName, color) {

  var objs = this.getObjects(objectsName);
  var step = (1 / 200);
  for (let i in objs) {
    if (color == "reset")
      objs[i].obj.material = objs[i].material.clone();
    else
      objs[i].obj.material.color.setHex(color);
    //      objs[i].material.specular.setHex(color)
    //      if (objs[i].material.opacity < opacity) {
    //         setOpacityUp(objs[i]);
    //      } else if (objs[i].material.opacity > opacity) {
    //         setOpacityDown(objs[i]);
    //      }
  }
  //   function setColor(obj) {
  //      if (obj.material.opacity> opacity) {
  //         obj.material.opacity -= step;
  //         requestAnimationFrame(function(){
  //            setOpacityDown(obj);
  //         });
  //      }
  //   }
  //   ;

  function setOpacityUp(obj) {
    if (obj.opacity < opacity) {
      obj.opacity += step;
      requestAnimationFrame(setOpacityUp);
    }
  }
}

visioneuse.prototype.getObjects = function(objectsName, debug) {
  if(debug == undefined){
    debug = false;
  }
  var objsList = [];
  var objsData = this.objects["all"];
  for (let i in objsData) {

    if (objectsName == "all")
      objsList.push(this.objects['all'][i]);
    else
      for (let y in objectsName) {
        //console.log(objectsName[y]+"||",  objsData[i].obj.name)
        if (objectsName[y] == objsData[i].obj.name) {
          objsList.push(this.objects['all'][i]);
        }
      }
  }
  return objsList;
}

visioneuse.prototype.buildMesh = function(firstShapeName) {
  var self = this;
  var THREE = th.THREE;
  var newGeometries = [];
  var oldOpacity = {};

  for (let i in self.combinedMeshs) {
    oldOpacity[i] = self.combinedMeshs[i].material[0].opacity;
  }

  newGeometries[firstShapeName] = self.geometries[firstShapeName];
  for (let i in self.geometries) {
    if (i != firstShapeName) {
      newGeometries[i] = self.geometries[i];
    }
  }
  self.geometries = newGeometries;

  for (let y in self.geometries) {
    var combinedMaterial = [];
    for (let i in self.arrayMaterials) {
      combinedMaterial[i] = self.arrayMaterials[i].clone();
      combinedMaterial[i].transparent = true;
    }
    var combinedMesh = new THREE.Mesh(self.geometries[y], combinedMaterial);
    self.combinedMeshs[y] = combinedMesh;


    for (let i in self.combinedMeshs) {
      for (let y in self.combinedMeshs[i].material) {
        if (oldOpacity[i] !== undefined)
          self.combinedMeshs[i].material[y].opacity = oldOpacity[i];
        else {

          self.combinedMeshs[i].material[y].opacity = 1;
        }
      }
    }

  }
}

visioneuse.prototype.buildExplodedMesh = function(firstShapeName) {
  var self = this;
  var THREE = th.THREE;
  var newGeometries = [];
  newGeometries[firstShapeName] = self.explodedGeometries[firstShapeName];
  for (let i in self.explodedGeometries) {
    if (i != firstShapeName) {
      newGeometries[i] = self.explodedGeometries[i];
    }
  }
  self.explodedGeometries = newGeometries;

  for (let y in self.explodedGeometries) {
    var combinedMaterial = [];
    for (let i in self.arrayMaterials) {
      combinedMaterial[i] = self.arrayMaterials[i].clone();
      combinedMaterial[i].transparent = true;
    }
    var combinedExplodedMeshs = new THREE.Mesh(self.explodedGeometries[y], combinedMaterial);
    self.combinedExplodedMeshs[y] = combinedExplodedMeshs;
  }
}

visioneuse.prototype.displayGroup = function(groupName, hideOpacity = 0.05) {
  //    if (this.combinedMeshs["all"].material[0].opacity >= 1) {
  for (let i in this.combinedMeshs) {
    scene.remove(this.combinedMeshs[i]);
  }

  this.buildMesh(groupName);
  this.addGroup();

  if (groupName != "all") {
    for (let i in this.combinedMeshs) {
      if (!this.combinedMeshs.hasOwnProperty(i))
        continue;

      if (i != groupName)
        nextStepHide(this.combinedMeshs[i]);
    }
    nextStepShow(this.combinedMeshs[groupName]);
  } else {
    for (let i in this.combinedMeshs) {
      nextStepShow(this.combinedMeshs[i]);
    }
  }
  var step = (1 / 10);

  function nextStepHide(mesh) {
    if (!mesh)
      return;
    if (mesh.material[0].opacity >= hideOpacity) {
      requestAnimationFrame(function() {
        for (let i in mesh.material) {
          mesh.material[i].opacity -= step;
        }
        nextStepHide(mesh);
      })
    } else {
      for (let i in mesh.material) {
        mesh.material[i].opacity = hideOpacity;
      }
    }
  }

  function nextStepShow(mesh) {
    if (!mesh)
      return;
    if (mesh.material[0].opacity < 1) {
      requestAnimationFrame(function() {
        for (let i in mesh.material) {
          mesh.material[i].opacity += step;
        }
        nextStepShow(mesh);
      })
    }
  }
}

visioneuse.prototype.addGroup = function() {
  if (this.group) {
    for (let i in this.combinedExplodedMeshs) {
      scene.remove(this.combinedExplodedMeshs[i]);
    }
    for (let i in this.combinedMeshs) {
      scene.add(this.combinedMeshs[i]);
    }
  } else {
    for (let i in this.objects["all"]) {
      scene.add(this.objects["all"][i].obj);
      scene.add(this.objects["all"][i].line);
    }
  }
}
// visioneuse.prototype.addExplodedGroup = function(groupName) {
//   scene.add(this.combinedExplodedMeshs[groupName]);
//
//
//   for (let i in this.combinedMeshs) {
//     scene.remove(this.combinedMeshs[i]);
//   }
// }

//visioneuse.prototype.explodeGroup = function (groupName) {
//   for (let i in this.objects[groupName]) {
//      let object = this.objects[groupName][i].obj;
//      let translation = this.objects[groupName][i].explodedTranslation;
//      object.position.set(translation[0], translation[2], -translation[1]);
//      object.updateMatrix();
//   }
//   this.buildGeometry(groupName);
//   this.displayGroup(groupName);
//}
visioneuse.prototype.mergeBackGroup = function(groupName) {
  for (let i in this.objects[groupName]) {
    let object = this.objects[groupName][i].obj;
    let translation = this.objects[groupName][i].explodedTranslation;
    object.position.set(0, 0, 0);
    object.updateMatrix();
  }
  this.buildGeometry(groupName);
  this.displayGroup(groupName);
}

visioneuse.prototype.initScene = function() {

  var self = this;
  var THREE = th.THREE;

  this.canvasContainer = document.getElementById(self.containerId);
  init();
  // initMaterial();
  initIndexbasedMaterial();

  controls = new THREE.OrbitControls(camera, renderer.domElement);
  controls.autoRotate = true;
  controls.autoRotateSpeed = 1;
  controls.enableDamping = true;
  controls.dampingFactor = 0.6;
  controls.rotateSpeed = 0.25;
  controls.maxDistance = 2000;
  controls.minDistance = 35;
  controls.zoomSpeed = 0.5;
  controls.enableTwoFingerZoomPan = true;
  controls.target.set(0, 25, 0);
  renderer.domElement.addEventListener('mousedown', function() {
    self.stopRotation();
  });
  renderer.domElement.addEventListener('touchstart', function() {
    self.stopRotation();
  });
  renderer.domElement.addEventListener('scroll', function() {
    self.stopRotation();
  });

  camera.position.set(955.48, 918.41, -765.85);
  camera.rotation.set(-2.36, 0.77, 2.54);
  controls.target.set(-93.93, 160.40, 4.10);

  function init() {

    scene = new THREE.Scene();

    if (!renderer) {
      var WIDTH = self.$$(self.canvasContainer).width(),
        HEIGHT = self.$$(self.canvasContainer).height();

      renderer = new THREE.WebGLRenderer({
        antialias: true,
        preserveDrawingBuffer: false,
      });
      renderer.setSize(WIDTH, HEIGHT);
      renderer.shadowMap.type = THREE.PCFShadowMap;

      window.addEventListener('resize', function() {


        var WIDTH = self.$$(self.canvasContainer).width(),
          HEIGHT = self.$$(self.canvasContainer).height();

        renderer.setSize(WIDTH, HEIGHT);
        camera.aspect = WIDTH / HEIGHT;
        camera.updateProjectionMatrix();
      });
    }

    scene.background = new THREE.Color(0xeeeeee);

    self.canvasContainer.appendChild(renderer.domElement);

    camera = new THREE.PerspectiveCamera(45, WIDTH / HEIGHT, 0.1, 10000);


    scene.add(camera);

    initLight();

    renderer.render(scene, camera);

  }

  function initLight() {

    addLight(2000, 0, 1000);
    addLight(0, 2000, 0); // dessus
    addLight(-2000, 0, -100); // derrière (- x ?)
    addLight(100, 500, -2000); // a droite
    addLight(-100, 500, 2000);

    function addLight(x, y, z) {
      var light = new THREE.PointLight(0xFFFFFF, 0.5);
      light.position.set(x, y, z);
      light.shadow.mapSize.Width = 1024; // default is 512
      light.shadow.mapSize.Width = 1024; // default is 512
      scene.add(light);
    }

  }

  function initIndexbasedMaterial() {
    var emissiveColor = 0x01EDDB;

    var colorMap = {
      'default': 0xD3D3D3,
      "MI": 0x19641c, //vert
      "M": 0x19641c, //vert
      'CG': 0xfdd915, //Jaune
      'CD': 0x111111, //noir
      'RG': 0xfdd915, //jaune
      'RC': 0xcc9966, //marron
      'RD': 0x111111, //noir
      'CH': 0xcc9966, //marron
      'P': 0xcc9966, //marron
      'T': 0xcc9966, //marron
      'MA': 0x355a98, //noir
      'PR': 0xcc9966, //marron
      'SH': 0x8B0000, //Rouge
      'S': 0x355a98, //noir
      'MD': 0x111111,
      'MG': 0xfdd915,
      'SQ':0x0000FF
    }

    self.materials = {};

    for (let i in colorMap) {
      self.materials[i] = new THREE.MeshPhongMaterial({
        color: colorMap[i],
        emissive: emissiveColor,
        emissiveIntensity: 0,
        specular: 0x000000,
        shininess: 0,
        envMap: null,
        transparent: true,
        opacity: 1,
        alphaTest: 0.5
      });
    }

    var cpt = 0;
    for (name in self.materials) {
      self.arrayMaterials.push(self.materials[name]);
      self.indexMaterials[name] = cpt;
      cpt++;
    }

  }

  function initMaterial() {
    var emissiveColor = 0x08DF37;
    self.materials = {

      'Bois noir': new THREE.MeshPhongMaterial({
        color: 0x111111,
        emissive: emissiveColor,
        emissiveIntensity: 0,
        specular: 0x000000,
        shininess: 0,
        envMap: null,
        transparent: true,
        opacity: 1,
        alphaTest: 0.5
      }),
      'Acier gris': new THREE.MeshPhongMaterial({

        color: 0x696a6c,
        emissive: emissiveColor,
        emissiveIntensity: 0,
        specular: 0xb9bfca,
        shininess: 5,
        envMap: null,
        transparent: true,
        opacity: 1,
        alphaTest: 0.5
      }),
      'Acier gris mirroir': new THREE.MeshPhongMaterial({

        color: 0xa4a5a6,
        emissive: emissiveColor,
        emissiveIntensity: 0,
        specular: 0xb9bfca,
        shininess: 5,
        envMap: null,
        transparent: true,
        opacity: 1,
        alphaTest: 0.5
      }),
      'Acier blanc': new THREE.MeshPhongMaterial({

        color: 0x4e4f50,
        emissive: emissiveColor,
        emissiveIntensity: 0,
        specular: 0x727374,
        shininess: 5,
        envMap: null,
        transparent: true,
        opacity: 1,
        alphaTest: 0.5
      }),
      'Acier bleui': new THREE.MeshPhongMaterial({

        color: 0x303553,
        emissive: emissiveColor,
        emissiveIntensity: 0,
        specular: 0x0f103e,
        shininess: 5,
        envMap: null,
        transparent: true,
        opacity: 1,
        alphaTest: 0.5
      }),
      'Bronze': new THREE.MeshPhongMaterial({

        color: 0xe2b383,
        emissive: emissiveColor,
        emissiveIntensity: 0,
        specular: 0x000000,
        shininess: 10,
        envMap: null,
        transparent: true,
        opacity: 1,
        alphaTest: 0.5
      }),
      'Caouchou rouge': new THREE.MeshPhongMaterial({

        color: 0x963c28,
        emissive: emissiveColor,
        emissiveIntensity: 0,
        specular: 0x000000,
        shininess: 1,
        envMap: null,
        transparent: true,
        opacity: 1,
        alphaTest: 0.5
      }),
      'Caouchou noir': new THREE.MeshPhongMaterial({

        color: 0x222222,
        emissive: emissiveColor,
        emissiveIntensity: 0,
        specular: 0x222222,
        shininess: 5,
        envMap: null,
        transparent: true,
        opacity: 1,
        alphaTest: 0.5
      }),
      'Corde': new THREE.MeshPhongMaterial({

        color: 0xFFFFFF,
        emissive: emissiveColor,
        emissiveIntensity: 0,
        specular: 0x151515,
        shininess: 5,
        envMap: null,
        transparent: true,
        opacity: 1,
        alphaTest: 0.5
      }),
      'Cuivre': new THREE.MeshPhongMaterial({

        color: 0xa57567,
        emissive: emissiveColor,
        emissiveIntensity: 0,
        specular: 0xd0b1ac,
        shininess: 10,
        envMap: null,
        transparent: true,
        opacity: 1,
        alphaTest: 0.5
      }),
      'Laiton': new THREE.MeshPhongMaterial({

        color: 0xd9be7b,
        emissive: emissiveColor,
        emissiveIntensity: 0,
        specular: 0x000000,
        shininess: 5,
        envMap: null,
        transparent: true,
        opacity: 1,
        alphaTest: 0.5
      }),
      'Email': new THREE.MeshPhongMaterial({

        color: 0xfef7e7,
        emissive: emissiveColor,
        emissiveIntensity: 0,
        specular: 0xfef7e7,
        shininess: 1,
        envMap: null,
        transparent: true,
        opacity: 1,
        alphaTest: 0.5
      }),

    };
    var cpt = 0;
    for (name in self.materials) {
      self.arrayMaterials.push(self.materials[name]);
      self.indexMaterials[name] = cpt;
      cpt++;
    }

  }
}

visioneuse.prototype.panCam = function(xTarget, yTarget, zTarget, xR, yR, zR, xCont, yCont, zCont,
  tweenDuration) {

  var TWEEN = tw.TWEEN;
  TWEEN.removeAll();
  var self = this;
  self.isPanning = true;

  var camNewPosition = {
    x: xTarget,
    y: yTarget,
    z: zTarget
  };
  var camNewRotation = {
    x: xR,
    y: yR,
    z: zR
  };
  var targetNewRotation = {
    x: xCont,
    y: yCont,
    z: zCont
  };

  var camTweenPos = new TWEEN.Tween(camera.position)
    .to(camNewPosition, tweenDuration)
    .easing(TWEEN.Easing.Quadratic.InOut)
    .start();

  var contTweenPos = new TWEEN.Tween(controls.target)
    .to(targetNewRotation, tweenDuration)
    .easing(TWEEN.Easing.Quadratic.InOut)
    .start()
    .onComplete(function() {
      self.isPanning = false;
    });
}

visioneuse.prototype.panToObjects = function(names){

  var TWEEN = tw.TWEEN;
  var THREE = th.THREE;
  objs = this.getObjects(names);
  var target = this.getCenterPoint(objs);

  var newPosition = new th.THREE.Vector3(0,0,0);
  newPosition.add(target);
  var newPositionOffset = newPosition.clone();

  var group = new THREE.Object3D();

  for(let i in objs){
    group.add(objs[i].obj.clone());
  }
  var box = new THREE.Box3().setFromObject(group);

  var dim = {
    h:box.max.z - box.min.z,
    w:box.max.x - box.min.x,
    d:box.max.y - box.min.y,
  };
  var maxDim = dim.h;

  if(dim.w > maxDim)
    maxDim = dim.w;

  if(dim.d > maxDim)
    maxDim = dim.d;

  maxDim = maxDim *2;

  newPositionOffset.clampLength(maxDim,maxDim);
  newPosition.add(newPositionOffset);
  this.panCam(
    newPosition.x, newPosition.y, newPosition.z,
    0, 0, 0,
    target.x, target.y, target.z,

     1500)

}

visioneuse.prototype.stopRotation = function() {
  controls.autoRotate = false;
}
visioneuse.prototype.startRotation = function() {
  controls.autoRotate = true;
}
module.exports = visioneuse;



// WEBPACK FOOTER //
// ./src/js/visioneuse/visioneuse.js